export const isActive = (section, currentSection) => section.id === currentSection